import { Box } from '@mui/system'
import React, { useEffect, useState } from 'react'
import { Legend, LoaderWrapper, ReportHeading, ReportOuterWrapper, MuiButton, CustomTabs, GraphGridTab } from '../../../../components'
import ReportsService from '../../../../services/reports.service'
import { useUpdateLhs, useReactQuery, useConditionalQuery } from '../../../../hooks'
import {
  exportExcel_addSegments,
  exportExcel_addPercentage,
  getObjectAsArray,
} from '../../../../util'
import { useGlobalStore } from '../../../../store'
import SegmentTable from './segmentTable'
import ComparisonTable from './comparisonTable'
import PercentSplitGraph from './percentSplit'
import CONFIG from './config'
import { IconArrowDown, IconArrowUpBig } from '../../../../assets/images/icons'
import PrismTopContent from '../reportPrism/prismTopContent'
import { ContentWrap, RootWrap } from './style'

const ReportSegmentV2 = (props) => {
  const [state, setState] = useState([])
  const [segmentData, setSegmentData] = useState(null)
  const [reportData, setReportData] = useState([])
  const [maxValue, setMaxValue] = useState(100)
  const [activeTab, setActiveTab] = useState(0)
  const [driversExcelData, setDriversExcelData] = useState()
  const { updateSubLhsApiLoaded } = useUpdateLhs()
  const [legendsData, setLegendsData] = useState([
    { label: 'Positive', value: 'Positive' },
    { label: 'Neutral', value: 'Neutral' },
    { label: 'Mixed', value: 'Mixed' },
    { label: 'Negative', value: 'Negative' },
  ])
  const [expandedStatus, setExpandedStatus] = useState(false)
  const [periodInOrder, setPeriodInOrder] = useState()
  const [eventCount, setEventCount] = useState(1)
  const { isPPTModalActive } = useGlobalStore()

  const [showTableGrid, setShowTableGrid] = useState('graph')

  const isPageType =
    props.isDriversProgression &&
    ['Triangulation', 'TriangulationComparisonViewOnly'].includes(props?.InsightsElementType)
      ? 'triangulationSection'
      : props.isDriversProgression
        ? 'driverProgressionSection'
        : 'SegmentSection'

  const useReactQueryObject = {
    payloadDetails: {
      queryId: [props.InsightsElementType, props.InsightsElementId],
      urlFunc: (['SegmentDriversOnlyAnalysis3Level', 'SegmentDriversOnlyAnalysisWithoutSentiments3Level'].includes(props.InsightsElementType)) ? ReportsService.GetSegmentDriversAnalysisWithDeepDiveElement :
        (isPageType === 'triangulationSection'
          ? ReportsService.GetTriangulationElement
          : isPageType === 'driverProgressionSection'
            ? ReportsService.getDriverProgressionElement
            : ReportsService.getSegmentDriversAnalysisElement),
      payload: { insightsElementId: props.InsightsElementId },
    },
  }

  // GetSegmentDriversAnalysisWithDeepDiveElement // this api we have to use ..

  const { data, isLoading, isSuccess, isError, error, refetch } = useConditionalQuery(useReactQueryObject, props)

  const getData = (dd, field = 'SegmentDrivers', isInner = true) => {
    const obj = {}
    const percentArr = []
    for (let index = 0; index < dd?.length; index++) {
      const element = dd[index]
      const driverElement = element?.[field]?.DriverElement
      const drivers = Array.isArray(driverElement)
        ? driverElement
        : Object.keys(driverElement || {})?.length
          ? [driverElement]
          : []
          
      for (let j = 0; j < drivers.length; j++) {
        const innerElement = drivers[j]
        const key = innerElement.DriverName

        const associationData = [{ SearchKeywords: innerElement.Percent }]
        const multiBarData = [{
          Positive: innerElement.PositivePercent,
          Neutral: innerElement.NeutralPercent,
          Mixed: innerElement.MixedPercent,
          Negative: innerElement.NegativePercent
        }]

        let keyName = isInner ? innerElement.TargetSegment : element.PeriodName

        obj[key] = {
          ...(obj[key] || {}),
          [keyName]: {
            ...innerElement,
            data: CONFIG[props.InsightsElementType]?.type ? associationData : multiBarData,
            // data: CONFIG[props.InsightsElementType]?.type === 'SearchKeywords' ? associationData : multiBarData,
          },
        }

        percentArr.push(innerElement.Percent)
      }
    }
    setMaxValue(Math.max(...percentArr))
    return obj
  }
  const updateExcelData__error = (data) => {
    const arr = { drivers: [], attributes: [], subAttributes: [] }
    const objArr1 = Object.keys(data)
    for (let i = 0; i < objArr1.length; i++) {
      const name1 = objArr1[i]
      const objArr2 = Object.keys(data[name1])
      for (let j = 0; j < objArr2.length; j++) {
        const name2 = objArr2[j]
        const obj = data[name1][name2]
        arr.drivers.push([
          { value: name1 },
          { value: name2 },
          ...exportExcel_addSegments(obj, true),
        ])
        const driverAttri = getObjectAsArray(obj?.DriverAttributes?.DriverAttributeElement || [])
        for (let k = 0; k < driverAttri.length; k++) {
          arr.attributes.push([
            { value: name1 },
            { value: name2 },
            { value: driverAttri[k].AttributeName },
            ...exportExcel_addSegments(driverAttri[k], true),
          ])
          let subDriverAttri = getObjectAsArray(
            driverAttri[k]?.DriverSubAttributes?.DriverSubAttributeElement || []
          )
          for (let m = 0; m < subDriverAttri.length; m++) {
            arr.subAttributes.push([
              { value: name1 },
              { value: name2 },
              { value: driverAttri[k].AttributeName },
              { value: subDriverAttri[m].SubAttributeName },
              ...exportExcel_addSegments(subDriverAttri[m], true),
            ])
          }
        }
      }
    }
    setDriversExcelData(arr)
  }

  
  const updateExcelData_2 = (data) => {
    const arr = { drivers: [], attributes: [], subAttributes: [] }
    const objArr1 = Object.keys(data)
    for (let i = 0; i < objArr1.length; i++) {
      const name1 = objArr1[i]
      const objArr2 = Object.keys(data[name1])
      for (let j = 0; j < objArr2.length; j++) {
        const name2 = objArr2[j]
        const obj = data[name1][name2]
        arr.drivers.push([
          { value: name1 },
          { value: name2 },
          ...exportExcel_addSegments(obj, true),
        ])
        const driverAttri = getObjectAsArray(obj?.DriverAttributes?.DriverAttributeElement || [])
        for (let k = 0; k < driverAttri.length; k++) {
          arr.attributes.push([
            { value: name1 },
            { value: name2 },
            { value: driverAttri[k].AttributeName },
            ...exportExcel_addSegments(driverAttri[k], true),
          ])
          let subDriverAttri = getObjectAsArray(
            driverAttri[k]?.DriverSubAttributes?.DriverSubAttributeElement || []
          )
          for (let m = 0; m < subDriverAttri.length; m++) {
            arr.subAttributes.push([
              { value: name1 },
              { value: name2 },
              { value: driverAttri[k].AttributeName },
              { value: subDriverAttri[m].SubAttributeName },
              ...exportExcel_addSegments(subDriverAttri[m], true),
            ])
          }
        }
      }
    }
    setDriversExcelData(arr)
  }

  const updateExcelData_1 = (data) => {
    const arr = [] // { drivers: [], attributes: [], subAttributes: [] }
    const arrWithAttribute = []
    const objArr1 = Object.keys(data)
    for (let i = 0; i < objArr1.length; i++) {
      const name1 = objArr1[i]
      const objArr2 = Object.keys(data[name1])
      for (let j = 0; j < objArr2.length; j++) {
        const name2 = objArr2[j]
        const obj = data[name1][name2]
        const attributes = Array.isArray(obj?.['DriverAttributes']?.['DriverAttributeElement'])
        ? obj?.['DriverAttributes']?.['DriverAttributeElement'] 
        : getObjectAsArray(obj?.['DriverAttributes']?.['DriverAttributeElement']);
        
        // Filter attributes that match current TargetSegment
        const filteredAttributes = attributes.filter(f => f.TargetSegment === name2);

        for (let k = 0; k < filteredAttributes.length; k++) {
          arrWithAttribute.push([
            { value: name1 },
            { value: name2 },
            { value: filteredAttributes[k].AttributeName },
            ...exportExcel_addSegments(filteredAttributes[k], true),
          ]);
        }
        // arr.push([{value: name1}, {value: name2}, {value: `${obj.PositivePercent}%`}, {value: `${obj.NeutralPercent}%`}, {value: `${obj.MixedPercent}%`}, {value: `${obj.NegativePercent}%`}, {value: `${obj.Percent}%`}])
        arr.push([{ value: name1 }, { value: name2 }, ...exportExcel_addSegments(obj, true)])
      }
    }
    setDriversExcelData({ array: arr, arrayWithAttribute: arrWithAttribute })
  }

  const updateExcelData  = (data) => {
    if( ['SegmentDriversOnlyAnalysis3Level', 'SegmentDriversOnlyAnalysisWithoutSentiments3Level'].includes(props.InsightsElementType) ){
      return updateExcelData_2(data)
    }
    return updateExcelData_1(data)
  }

  const expandCollapseFunc = (flag) => {
    setExpandedStatus(flag)
  }

  useEffect(() => {
    if (props?.driversSegmentsExpanded) {
      setExpandedStatus(true)
    }
  }, [props?.driversSegmentsExpanded])

  useEffect(() => {
    setEventCount((p) => p + 1)
  }, [state, segmentData, expandedStatus])

  const AdditionalButtons = ({ expandedStatus, expandCollapseFunc, expanded, showTableGrid, setShowTableGrid }) => {
    return (
      <>
        <GraphGridTab show={showTableGrid} onClick={(p) => setShowTableGrid(p)} />
        <MuiButton
          variant='outlined'
          color='light'
          startIcon={expandedStatus ? <IconArrowUpBig /> : <IconArrowDown />}
          onClick={() => expandCollapseFunc(!expandedStatus)}
        >
          {expandedStatus ? 'Collapse All' : 'Expand All'}
        </MuiButton>
      </>
    )
  }

  const getDriverProgression = (resp) => {
    const sd = getData(resp, 'PeriodDrivers', false)
    setSegmentData(sd)
    updateExcelData(sd)

    const dd = resp.map((item) => ({
      ...item,
      SegmentDrivers: item.PeriodDrivers,
    }))
    setReportData(dd)
    updateSubLhsApiLoaded(props)
  }

  const getTriangulation = (resp) => {
    const sd = getData(resp, 'TriangulationSubDrivers', false)
    setSegmentData(sd)
    updateExcelData(sd)

    const dd = resp.map((item) => ({
      ...item,
      SegmentDrivers: item.PeriodDrivers,
    }))
    setReportData(dd)

    updateSubLhsApiLoaded(props)
  }

  const getSegment = (resp) => {
    if (!props?.isDriversProgression) {
      const averageStarRating = resp.map((item) => {
        return {
          SegmentType: item.SegmentType,
          SegmentName: item.SegmentName,
          SegmentMaxValue: item.SegmentMaxValue,
          SegmentValue: item.SegmentValue,
          type: 'Association',
          data: [
            {
              0: item.SegmentValue,
            },
          ],
        }
      })
      setState([
        {
          SegmentType: averageStarRating[0]?.SegmentType,
          data: averageStarRating,
          id: `percentGraph_${props?.InsightsElementId?.replaceAll('-','') || 'static'}`
        },
      ])
    }
    const sd = getData(resp)
    setSegmentData(sd)
    updateExcelData(sd)

    setReportData(resp)
    updateSubLhsApiLoaded(props)
  }

  const onSuccessFunc = (resp) => {
    if (isPageType === 'triangulationSection') {
      getTriangulation(resp)
    } else if (isPageType === 'driverProgressionSection') {
      getDriverProgression(resp)
    } else {
      getSegment(resp)
    }
  }

  useEffect(() => {
    if (isSuccess && data?.length) onSuccessFunc(data)
  }, [isSuccess, data, activeTab])

  useEffect(() => {
    if (isPPTModalActive && state?.length > 0) {
      setTimeout(() => {
        updateSubLhsApiLoaded(props)
      },1000)
    }
  }, [isPPTModalActive, state])

  return (
    <>
      {state && segmentData && driversExcelData && (
        <ReportHeading
          resetInsightHeight={eventCount+activeTab}
          downloadId={props.type}
          downloadIdData={driversExcelData}
          pptData={{data:{percentSplit:state?.[0] || [], segmentData:segmentData}, settings:{}}}
          {...props}
          additionalButton={
            <AdditionalButtons
              expandedStatus={expandedStatus}
              expandCollapseFunc={expandCollapseFunc}
              expanded={expandedStatus}
              showTableGrid={showTableGrid}
              setShowTableGrid={setShowTableGrid}
            />
          }
          addTable={true}
        />
      )}
      {isPPTModalActive && state?.length > 0 && ['SegmentDriversAnalysis'].includes(props?.InsightsElementType) && <PercentSplitGraph data={state} />}

      <PrismTopContent prismData={props.prismData} />
      <ReportOuterWrapper type={props?.InsightsElementType}>
        <RootWrap id={props.type} className={`${props.InsightsElementType} ${props?.isPPTModalActive ? 'exportToPPT' : ''}`}>
          <LoaderWrapper
            loadOnlyApi={props.loadOnlyApi}
            isLoading={isLoading}
            isSuccess={isSuccess}
            isError={isError}
            error={error}
          >
            {!!Object?.keys(segmentData || {})?.length && (
              <>
                <ContentWrap className='segmentWrapper 77777777777'>
                  <CustomTabs
                    options={CONFIG[props.InsightsElementType]?.tabs || undefined}
                    onChange={setActiveTab}
                    value={activeTab}
                    styletype='themeV2'
                  />
                  {activeTab === 0 ? (
                    <ComparisonTable
                      attributeColor={CONFIG[props.InsightsElementType]?.attributeColor}                      
                      keyOrdering={reportData.map((d) => d?.PeriodName || d?.SegmentName)}
                      isSearchDrivers={props.isSearchDrivers}
                      maxValue={maxValue}
                      data={state}
                      segmentData={segmentData}
                      type={CONFIG[props.InsightsElementType]?.type}
                      filterType={CONFIG[props.InsightsElementType]?.filterType}
                      insightsElementType={props.InsightsElementType}
                      expanded={expandedStatus}
                      filterUpdated={() => setEventCount((p) => p + 1)}
                      periodInOrder={periodInOrder}
                      // isSegmentsComponent={isSegmentsComponent}
                      showTableGrid={showTableGrid}
                    />
                  ) : (
                    <SegmentTable
                      data={reportData}
                      isSearchDrivers={props.isSearchDrivers}
                      showAttributes={!props?.isDriversProgression}
                      hideTopBlueBar={props.hideTopBlueBar}
                      type={CONFIG[props.InsightsElementType]?.type}
                      attributeColor={CONFIG[props.InsightsElementType]?.attributeColor}
                      insightsElementType={props.InsightsElementType}
                      showTableGrid={showTableGrid}
                      maxValue={maxValue}
                      props={props}
                    />
                  )}
                  {activeTab === 0 && CONFIG[props?.InsightsElementType]?.showLegends && (
                    <Box sx={{ display: 'flex', justifyContent: 'end', marginTop: '30px' }}>
                      <Legend legends={legendsData} />
                    </Box>
                  )}
                </ContentWrap>
              </>
            )}
          </LoaderWrapper>
        </RootWrap>
      </ReportOuterWrapper>
    </>
  )
}

export default ReportSegmentV2
